import type { Product } from '../domain/models';
import { useTranslation } from 'src/lib/i18n/useTranslation';
import { Offscreen } from 'src/lib/common/ui/Offscreen';
import { WheelText } from 'src/lib/common/ui/WheelText';
import wheelText from 'src/lib/assets/wheelText';
import { TasteWheelFull } from '../../assets/graphics';
import styles from './ProductTasteGraphic.module.scss';

interface ProductTasteGraphicProps {
  product: Product,
  displayMode: 'full' | 'preview',
}

export function ProductTasteGraphic(props: ProductTasteGraphicProps) {
  const { t } = useTranslation();

  // create data strings for svg:
  const flavourDataString = (props.product?.tasteGraph.flavour && props.product.tasteGraph.flavour.length > 0)
    ? `|${(props.product?.tasteGraph.flavour || []).join('|')}|`
    : '';
  const mouthfeelDataString = (props.product?.tasteGraph.mouthfeel && props.product.tasteGraph.mouthfeel.length > 0)
    ? `|${(props.product?.tasteGraph.mouthfeel || []).join('|')}|`
    : '';
  const tasteDataString = (props.product?.tasteGraph.taste && props.product.tasteGraph.taste.length > 0)
    ? `|${(props.product?.tasteGraph.taste || []).join('|')}|`
    : '';
  const outerflavourDataString = (props.product?.tasteGraph.outer_flavour && props.product.tasteGraph.outer_flavour.length > 0)
    ? `|${(props.product?.tasteGraph.outer_flavour || []).join('|')}|`
    : '';
  const tasteDimensionDataString = (props.product?.tasteGraph.taste_dimension && props.product.tasteGraph.taste_dimension.length > 0)
    ? `|${(props.product?.tasteGraph.taste_dimension || []).join('|')}|`
    : '';

  // create text string for use as image alternative:
  const readableFlavour = (props.product?.tasteGraph.flavour || []).map((value) => value.replace(/_/g, ' ')).join(', ');
  const readableMouthfeel = (props.product?.tasteGraph.mouthfeel || []).map((value) => value.replace(/_/g, ' ')).join(', ');
  const readableTaste = (props.product?.tasteGraph.taste || []).map((value) => value.replace(/_/g, ' ')).join(', ');
  const readableOuterFlavour = (props.product?.tasteGraph.outer_flavour || []).map((value) => value.replace(/_/g, ' ')).join(', ');
  const readableTasteDimension = (props.product?.tasteGraph.taste_dimension || []).map((value) => value.replace(/_/g, ' ')).join(', ');

  return (
    <div className={ styles.container }>

      <div
        data-language={ wheelText.language }
        data-flavourids={ flavourDataString }
        data-tasteids={ tasteDataString }
        data-mouthfeelids={ mouthfeelDataString }
        data-outerflavourids={ outerflavourDataString }
        data-tastedimensionids={ tasteDimensionDataString }
        className={ styles.svgHolder }
        aria-hidden="true">
          <TasteWheelFull />
          <WheelText variant={ props.displayMode } />
      </div>

      <Offscreen as='div'>
        <dl>
          <dt>{ t('results_tasteprofile_flavour_title') }</dt>
          <dd>{ readableFlavour }</dd>
          <dt>{ t('results_tasteprofile_detailedflavour_title') }</dt>
          <dd>{ readableOuterFlavour }</dd>
          <dt>{ t('results_tasteprofile_mouthfeel_title') }</dt>
          <dd>{ readableMouthfeel }</dd>
          <dt>{ t('results_tasteprofile_taste_title') }</dt>
          <dd>{ readableTaste }</dd>
          <dt>{ t('results_tasteprofile_tastedimension_title') }</dt>
          <dd>{ readableTasteDimension }</dd>
        </dl>
      </Offscreen>

    </div>
  );
}
